var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import config from "@/config";
import SplashGame from "@/lib/SplashGame";
import { AD_TYPE } from "@/lib/SplashGame/AdHandler";
import CustomControls from "@/prefabs/custom/Controls";
import PanelGameEnd from "@/prefabs/custom/Panel/GameEnd";
import PanelHint from "@/prefabs/custom/Panel/Hint";
import PanelInformation from "@/prefabs/custom/Panel/Information";
import PanelLeaderboard from "@/prefabs/custom/Panel/Leaderboard";
import PanelNotification from "@/prefabs/custom/Panel/Notification";
import PanelRespawn from "@/prefabs/custom/Panel/Respawn";
import PanelServerStatus from "@/prefabs/custom/Panel/ServerStatus";
import PanelSettings from "@/prefabs/custom/Panel/Settings";
import PanelStart from "@/prefabs/custom/Panel/Start";
import PanelTimer from "@/prefabs/custom/Panel/Timer";
import UtilsScreen from "@/lib/utils/screen";
var GameplayPanels = /** @class */ (function () {
    function GameplayPanels() {
    }
    GameplayPanels.getInstance = function () {
        if (!this._instance) {
            this._instance = new GameplayPanels();
        }
        return this._instance;
    };
    GameplayPanels.prototype.load = function (scene) {
        var _this = this;
        this.scene = scene;
        var _a = this.scene, camera = _a.camera, player = _a.player, settings = _a.settings;
        // game end
        this.panel_gameEnd = new PanelGameEnd(this.scene, function () {
            return _this.reward_claim_x2();
        });
        // hint
        this.panel_hint = new PanelHint(this.scene, 0, 0);
        this.panel_hint.setVisible(false);
        this.scene.time.addEvent({
            delay: 5000,
            callback: function () { return _this.panel_hint.destroy(); },
            loop: false,
        });
        // information panel
        this.panel_information = new PanelInformation(this.scene, 0, 0, 0);
        this.panel_information.setVisible(false);
        this.panel_information.setValues(1, 0);
        // leaderboard
        this.panel_leaderboard = new PanelLeaderboard(this.scene, 0, 0);
        this.panel_leaderboard.setVisible(false);
        this.onLeaderboardUpdate();
        this.scene.time.addEvent({
            callback: function () {
                _this.onLeaderboardUpdate();
            },
            delay: 1000,
            loop: true,
        });
        // notification
        this.panel_notification = new PanelNotification(this.scene, 0, 0, player.getUser().username);
        this.panel_notification.setVisible(false);
        // respawn
        this.panel_respawn = new PanelRespawn(this.scene, function () {
            _this.reward_revive();
        });
        // server status
        this.panel_serverStatus = new PanelServerStatus(this.scene, 0, 0);
        this.panel_serverStatus.setVisible(false);
        this.panel_serverStatus.setPing(8);
        // settings
        this.panel_settings = new PanelSettings(this.scene, 0, 0, camera.displayWidth, camera.displayHeight, function () { return _this.panel_settings.setVisible(false); }, function (isActive) { return (settings.audio = isActive); }, function (isActive) { return (settings.sfx = isActive); }, settings);
        this.panel_settings.setVisible(false);
        // start
        this.panel_start = new PanelStart(scene, function () {
            _this.panel_start.hide(function () {
                scene.start_game();
                _this.custom_controls.setVisible(true);
            });
        });
        // timer
        this.panel_timer = new PanelTimer(this.scene, 0, 0);
        this.panel_timer.setVisible(false);
        // custom controls
        this.custom_controls = new CustomControls(this.scene);
        this.custom_controls.setVisible(false);
        //
        this.resize();
    };
    GameplayPanels.prototype.setControls = function (listener_move, listener_attack) {
        this.custom_controls.setOnMove(listener_move);
        this.custom_controls.setOnAttack(listener_attack);
    };
    GameplayPanels.prototype.onTimerUpdate = function (time) {
        this.panel_timer.setTime(time);
    };
    GameplayPanels.prototype.onPlayerDeath = function (is_alive) {
        if (is_alive) {
            this.panel_respawn.setVisible(false);
            this.custom_controls.setVisible(true);
            return;
        }
        this.panel_respawn.setVisible(true);
        this.custom_controls.setVisible(false);
    };
    GameplayPanels.prototype.onLeaderboardUpdate = function () {
        this.panel_leaderboard.update(this.scene.player.getValue().username, __spreadArray([this.scene.player], this.scene.enemies, true).sort(function (a, b) {
            return b.getScore() - a.getScore();
        })
            .map(function (e, i) { return ({
            index: i,
            username: e.getValue().username,
            score: e.getScore(),
        }); }));
        this.panel_information.setValues(this.scene.player.getValue().game.level + 1, this.scene.player.getValue().game.count_kill);
    };
    GameplayPanels.prototype.onGameEnd = function (values) {
        this.panel_hint.setVisible(false);
        this.panel_information.setVisible(false);
        this.panel_notification.setVisible(false);
        this.panel_respawn.setVisible(false);
        this.panel_timer.setVisible(false);
        this.custom_controls.setVisible(false);
        this.game_end_data = values;
        this.panel_gameEnd.setValues(this.game_end_data.game.score, this.game_end_data.game.count_kill);
        this.panel_gameEnd.setVisible(true);
    };
    GameplayPanels.prototype.reward_claim_x2 = function () {
        var _this = this;
        SplashGame.AdHandler.getInstance().showAds(AD_TYPE.REWARDED, function () {
            if (!_this.scene)
                return;
            var _a = _this.game_end_data, username = _a.username, _b = _a.game, score = _b.score, count_kill = _b.count_kill;
            var newScore = score * 2;
            _this.panel_gameEnd.setValues(newScore, count_kill);
            _this.panel_leaderboard.updateLocal(username, newScore);
        });
    };
    GameplayPanels.prototype.reward_revive = function () {
        var _this = this;
        SplashGame.AdHandler.getInstance().showAds(AD_TYPE.REWARDED, function () {
            if (!_this.scene)
                return;
            _this.scene.player.NOTIFY_ALIVE();
        });
    };
    GameplayPanels.prototype.resize = function () {
        var _a = UtilsScreen.safe_area(this.scene), x_min = _a.x_min, x_max = _a.x_max, y_min = _a.y_min, y_max = _a.y_max, width = _a.width, height = _a.height;
        var _width = x_max - x_min;
        var _height = y_max - y_min;
        // game end
        this.panel_gameEnd.resize(_width, _height);
        // hint
        this.panel_hint.resize(_width, _height);
        this.panel_hint.setPosition(width / 2, y_max);
        this.panel_hint.setVisible(true);
        // information
        this.panel_information.resize(_width, _height);
        this.panel_information.setPosition(width / 2, y_min);
        this.panel_information.setVisible(true);
        // leaderboard
        this.panel_leaderboard.resize(_width, _height);
        this.panel_leaderboard.setPosition(x_min + config.graphics.viewbox.x, height / 2);
        this.panel_leaderboard.setVisible(true);
        // notification
        this.panel_notification.resize(_width, _height);
        this.panel_notification.setPosition(width / 2, this.panel_information.y);
        // respawn
        this.panel_respawn.resize(_width, _height);
        // server status
        // this.panel_serverStatus.setPosition(
        //   width - config.graphics.viewbox.x,
        //   height - config.graphics.viewbox.y
        // );
        // this.panel_serverStatus.setVisible(true);
        // settings
        // this.panel_settings.setPosition(x_min, x_max);
        // this.panel_settings.setVisible(true);
        // start
        this.panel_start.resize(_width - config.graphics.viewbox.x * 2, _height);
        // timer
        this.panel_timer.resize(_width, _height);
        this.panel_timer.setPosition(x_max, this.panel_information.y);
        this.panel_timer.setVisible(false);
        // custom controls
        this.custom_controls.resize(_width, _height);
    };
    return GameplayPanels;
}());
export default GameplayPanels;
